import {useState} from 'react'
import {Tooltip} from '@mui/material'
import classnames from 'classnames'

import {formatPhoneNumber} from '../../../../lib/contactTools'

import PhoneIcon from './PhoneIcon'

import './phoneButton.scss'

const PhoneButton = ({className, phoneNumber}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  
  return (
    <Tooltip
      arrow
      slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -6],
                },
              },
            ],
          },
        }}
      PopperProps={{
        disablePortal: true,
      }}
      onClose={() => setShowTooltip(false)}
      open={showTooltip}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      title={formatPhoneNumber(phoneNumber)}>
      <div
        className={classnames('phone-button', className)}
        onClick={() => setShowTooltip(!showTooltip)}>
        <PhoneIcon />
        Phone
      </div>
    </Tooltip>
  )
}

export default PhoneButton
